import React, { useRef, useState, useEffect } from "react";

const ArticleCreateStep3 = ({
  photos,
  visibleCount,
  currentIndex,
  setCurrentIndex,
  formArticle,
  infoCle,
  next,
  prev,
  handleChange,
  user,
}) => {
  const containerRef = useRef(null);
  const [slideWidth, setSlideWidth] = useState(0);

  const updateSlideWidth = () => {
    if (!containerRef.current) return;
    const isMobile = window.innerWidth < 768;
    const visible = isMobile ? 1 : Math.min(photos.length, 3);
    setSlideWidth(containerRef.current.offsetWidth / visible);
  };

  // On mount + resize
  useEffect(() => {
    updateSlideWidth();
    window.addEventListener("resize", updateSlideWidth);
    return () => window.removeEventListener("resize", updateSlideWidth);
  }, [photos.length]);

  return (
    <div className="container">
      <div className="content_article_create_info">
        <div className="preview_card">
          <div className="recap_gallery_container" ref={containerRef}>
            {photos.length > visibleCount && currentIndex > 0 && (
              <button
                className="carousel_btn left"
                onClick={() => setCurrentIndex((i) => i - 1)}
              >
                ‹
              </button>
            )}

            <div
              className="recap_carousel"
              style={{
                transform: `translateX(-${currentIndex * slideWidth}px)`,
              }}
            >
              {photos.map((p, i) => (
                <img
                  key={i}
                  src={p.url}
                  className="recap_img_large"
                  style={{
                    width: `${slideWidth - 9}px`,
                  }}
                  alt="recap"
                />
              ))}
            </div>

            {photos.length > visibleCount &&
              currentIndex < photos.length - visibleCount && (
                <button
                  className="carousel_btn right"
                  onClick={() => setCurrentIndex((i) => i + 1)}
                >
                  ›
                </button>
              )}
          </div>

          <div className="preview_details">
            <h2>{formArticle.titre}</h2>
            {formArticle?.prix && formArticle.prix > 0 ? (
              <p className="preview_price">
                {Number(formArticle?.prix).toLocaleString()} MGA
              </p>
            ) : null}
            <div className="preview_meta">
              <small>
                {formArticle.ville}, {formArticle.quartier}
              </small>
            </div>
          </div>
        </div>

        <div className="preview_info_cle">
          <div className="info_cle_section d-none">
            <span className="titre_recap_infos_cle">Les informations clés</span>
            {infoCle.length === 0 && <p>Aucune information clé ajoutée.</p>}
            <div className="info_cle_table">
              {infoCle.map((item, i) => (
                <div key={i} className="info_cle_row">
                  <div className="info_cle_icon">
                    <i className={`bi bi-${item.icon}`}></i>
                  </div>
                  <div className="info_cle_name">{item.name}</div>
                  <div className="info_cle_value">{item.value}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="info_cle_section" style={{ height: "auto" }}>
            <span className="titre_recap_description" style={{ margin: "0" }}>
              Description
            </span>
            <div className="content_description">
              {/* <div className="content_description"> */}
              {formArticle.description
                ? formArticle.description.split(/\r?\n/).map((line, index) => (
                    <div
                      className="texte_description"
                      key={index}
                      style={{ marginLeft: "0 !important" }}
                    >
                      {line}
                      <br />
                    </div>
                  ))
                : "Aucune description disponible"}
              {/* </div> */}
            </div>
          </div>
          {/* Champ et options pour marquer l'article comme test seuement pour les comptes test*/}
          {user.typeCompte === 3 && (
            <div className="article_test_option">
              <div className="article_test_option_text">
                <span className="article_test_option_title">
                  Article de test
                </span>
                <span className="article_test_option_desc">
                  Ne sera pas visible publiquement
                </span>
              </div>

              <label className="article_test_switch">
                <input
                  type="checkbox"
                  checked={Number(formArticle.isTest) === 1}
                  onChange={(e) =>
                    handleChange({
                      target: {
                        name: "isTest",
                        value: e.target.checked ? 1 : 2,
                      },
                    })
                  }
                />
                <span className="article_test_switch_slider"></span>
              </label>
            </div>
          )}

          <button
            className="article_create_btn_continuer"
            onClick={next}
            style={{ marginTop: "30px", width: "100%" }}
          >
            Valider
          </button>
          <button className="article_create_btn_retour" onClick={prev}>
            Retour
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArticleCreateStep3;
